import { render } from "./customer-contract-details.vue?vue&type=template&id=3c5cc703"
import script from "./customer-contract-details.vue?vue&type=script&lang=js"
export * from "./customer-contract-details.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__